import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import apiService from '../services/api';
import { Alert, AlertsResponse } from '../types/api';

export const useAlertsCount = () => {
  const { data, isLoading, error } = useQuery<AlertsResponse>({
    queryKey: ['alerts-count'],
    queryFn: (): Promise<AlertsResponse> => apiService.getAlerts(false),
    refetchInterval: 10000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
    staleTime: 5000,
  });

  const unacknowledgedCount = useMemo(() => {
    const alerts: Alert[] = data?.alerts ?? [];
    return alerts.filter((alert) => !alert.is_acknowledged).length;
  }, [data]);

  const hasAlerts = unacknowledgedCount > 0;

  return {
    count: unacknowledgedCount,
    isLoading,
    error,
    hasAlerts,
  };
};